// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { navigateToUrl } from '@tcp/core/src/components/common/molecules/SearchBar/WebSearchBar/helpers/webSearchUiHelper';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import style from '../styles/SearchSuggestionLayout.style';
import IAmLookingFor from './IAmLookingFor.view';
import TrendingSearchList from './TrendingSearchList.view';
import FeaturedProducts from './FeaturedProducts.view';
import PreviousSearches from './PreviousSearches.view';
import useSearchLayout from '../utils/NewSearchBar.util';

const SearchSuggestionLayout = (props) => {
  const {
    className,
    isReturningUser,
    redirectToSuggestedUrl,
    redirectToProductUrl,
    searchInput,
    closeSearchBar,
    onCloseClick,
    isSearchBarAutosuggestProductsEnabled,
    cmsTrendingSearchResults,
    searchSuggestionLayoutRedesign,
  } = props;
  const hasMounted = useHasMounted();
  const {
    isSuggestionFound,
    showIAmLookingFor,
    searchResultData,
    trendingSearchList,
    featuredProductList,
    previousSearchList,
  } = useSearchLayout({ ...props, isMobile: false });
  const isCmsTrending = cmsTrendingSearchResults?.length > 0;
  const newtrendingList = isCmsTrending ? cmsTrendingSearchResults : trendingSearchList;

  return (
    <div
      className={`${className} search-bar-desktop-layout ${
        searchSuggestionLayoutRedesign ? 'search-bar-desktop-layout-redesign' : ''
      }`}
    >
      <div
        className={`text-list-content ${!featuredProductList?.length && 'no-matches'} ${
          searchSuggestionLayoutRedesign && 'redesign'
        }`}
      >
        {showIAmLookingFor ? (
          <IAmLookingFor
            searchInput={searchInput}
            searchResultData={searchResultData}
            isSuggestionFound={isSuggestionFound}
            redirectToSuggestedUrl={redirectToSuggestedUrl}
            redesign={searchSuggestionLayoutRedesign}
          />
        ) : (
          <TrendingSearchList
            trendingSearchList={newtrendingList}
            closeSearchBar={closeSearchBar}
            navigateToUrl={navigateToUrl}
            onCloseClick={onCloseClick}
            isCmsTrending={isCmsTrending}
            redesign={searchSuggestionLayoutRedesign}
          />
        )}
      </div>
      <div className={`product-list-content ${searchSuggestionLayoutRedesign && 'redesign'}`}>
        {hasMounted && isReturningUser && !searchInput?.current?.value ? (
          <PreviousSearches
            previousSearchList={previousSearchList}
            closeSearchBar={closeSearchBar}
            onCloseClick={onCloseClick}
            redesign={searchSuggestionLayoutRedesign}
          />
        ) : (
          <FeaturedProducts
            featuredProductList={featuredProductList}
            redirectToProductUrl={redirectToProductUrl}
            onCloseClick={onCloseClick}
            isSearchBarAutosuggestProductsEnabled={isSearchBarAutosuggestProductsEnabled}
            searchInput={searchInput}
            closeSearchBar={closeSearchBar}
            redesign={searchSuggestionLayoutRedesign}
          />
        )}
      </div>
    </div>
  );
};

SearchSuggestionLayout.propTypes = {
  className: PropTypes.string.isRequired,
  isReturningUser: PropTypes.bool,
  searchResults: PropTypes.shape({}),
  searchInput: PropTypes.shape({}),
  redirectToSuggestedUrl: PropTypes.func.isRequired,
  closeSearchBar: PropTypes.func.isRequired,
  redirectToProductUrl: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  isSearchBarAutosuggestProductsEnabled: PropTypes.bool.isRequired,
};
SearchSuggestionLayout.defaultProps = {
  isReturningUser: false,
  searchResults: {},
  searchInput: null,
};
export { SearchSuggestionLayout as SearchSuggestionLayoutVanilla };
export default withStyles(SearchSuggestionLayout, style);
